module.exports = "<div class=\"drzSection-divider\">\n  <?xml version=\"1.0\" encoding=\"utf-8\"?>\n  <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n  \t viewBox=\"0 0 1200 91\" style=\"enable-background:new 0 0 1200 91;\" xml:space=\"preserve\">\n  <polygon class=\"st0 drz-divider-shape\" points=\"0,91 600,0 1200,91 \"/>\n  </svg>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/droplets/section/components/shape-dividers/point-up/template.html
// module id = ZfHy
// module chunks = 0